import { createFileRoute } from '@tanstack/react-router'
import AdminOrganizations from '@/features/admin/organizations'

export const Route = createFileRoute('/_admin/admin/')({
  component: AdminOrganizations,
})
